// ----------------------------------------------------------------------------
// ActiveBidsView — "Active Bids" page composition.
// Wires the KPI cards + interactive ledger + slide-out drawer together.
// ----------------------------------------------------------------------------

import React, { useMemo, useState } from "react";
import { KpiCards } from "../KpiCards";
import { BidLedger } from "../BidLedger";
import { BidDrawer } from "../BidDrawer";
import { ACTIVE_BIDS } from "../../data/mockData";

// Closing-this-week predicate: bids closing within the current calendar week
// (Mon–Sun) relative to the seeded 2026 reference date. With seed data this
// resolves to 2 (06-09 and 06-11 within the 06-08..06-14 window).
const closingThisWeekCount = (bids, now = new Date("2026-06-08")) => {
  const start = new Date(now);
  const end = new Date(now);
  end.setDate(end.getDate() + 6); // Mon..Sun inclusive
  return bids.filter((b) => {
    const d = new Date(b.closing + "T00:00:00");
    return d >= start && d <= end;
  }).length;
};

export const ActiveBidsView = () => {
  const [selectedBid, setSelectedBid] = useState(null);

  // Memoize derived KPI values to mirror what a real query would return.
  const kpi = useMemo(
    () => ({
      total: ACTIVE_BIDS.length,
      contractValue: "$650,000+",
      closingThisWeek: closingThisWeekCount(ACTIVE_BIDS),
    }),
    [],
  );

  return (
    <div className="space-y-8">
      <header className="space-y-2">
        <p className="text-[11px] uppercase tracking-[0.18em] text-sky-700 font-semibold">
          Brevard · Palm Bay · West Melbourne
        </p>
        <h1 className="font-display text-3xl sm:text-4xl font-semibold tracking-tight text-slate-900">
          Space Coast Procurement Portal
        </h1>
        <p className="text-slate-500 max-w-2xl text-sm sm:text-base leading-relaxed">
          A live ledger of active municipal bids across Florida's Space Coast.
          Track scope, agency, and bonding requirements in one workspace.
        </p>
      </header>

      <KpiCards
        totalActive={kpi.total}
        contractValue={kpi.contractValue}
        closingThisWeek={kpi.closingThisWeek}
      />

      <BidLedger bids={ACTIVE_BIDS} onRowClick={setSelectedBid} />

      <BidDrawer
        bid={selectedBid}
        open={!!selectedBid}
        onClose={() => setSelectedBid(null)}
      />
    </div>
  );
};
